import * as React from "react";
import {RaisedButton} from "../common/RaisedButton";
import {defaultButtonStyle} from "../common/buttonStyles";
import {FormattedMessage} from "react-intl";
import {getTranslation} from "../../utils/translationUtil";
import {DocumentType, documentTypeEnumKeyFromValue} from "../../utils/marketOutlookUtils";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";


export const INSIGHT_DESCRIPTION = "Aon’s outlooks on investment markets and economies and how your investments may " +
    "be impacted";

export const HomeInsights: React.FunctionComponent = () => {
    const navigate = useNavigate();
    const renderInsightsButton = () => {
        return <RaisedButton
            className="home-insights__insights-button"
            style={ defaultButtonStyle }
            onClick={() => {navigateTo("/white-papers", navigate);}}
            primary={true}
        >
            <FormattedMessage id="home.button.insights" defaultMessage="Insights" />
        </RaisedButton>;
    };

    const renderInsightsLink = (documentType: DocumentType, translationId: string) => {
        const key = documentTypeEnumKeyFromValue(documentType);
        return <div className="home-insights__link-card"
                    onClick={() => {navigateTo(`/market-outlooks?document-type=${key}`, navigate);}}
                    data-testid={`home-insights__link-card-${documentType}`}>
            <div className={`home-insights__link-image-${key.toLowerCase()}`}/>
            <div className="home-insights__link-title" >
                {getTranslation(translationId,
                    documentType === DocumentType.QIO ? "Quarterly Outlook" : documentType)}
            </div>
        </div>;
    };

    return <div className="home-insights__container">
        <div className="home-insights__title-container">
            <div className="home-insights__title">{getTranslation("home.insights", "Latest Insights")}</div>
            <div className="home-insights__description">
                {getTranslation("home.insight.description", INSIGHT_DESCRIPTION)}
            </div>
            <div className="home-insights__button-container">{renderInsightsButton()}</div>
        </div>
        <div className="home-insights__links-container">
            {renderInsightsLink(DocumentType.MTV, "filters.medium-term-views")}
            {renderInsightsLink(DocumentType.CMA, "filters.capital-market-assumptions")}
            {renderInsightsLink(DocumentType.QIO, "home.insight.image-title-qio")}
            {renderInsightsLink(DocumentType.MB, "filters.market-background")}
        </div>
    </div>;
};